export default __webpack_public_path__ + "static/media/maths-bg-small.f1e3ec5d.webp";